export default __webpack_public_path__ + "static/media/calendar.58fa5782.jpg";